import "./multi-section-warning.less";
import template from "./multi-section-warning.html";

function countMultiSections(sections = []) {
	const visitedSections = new Set();

	function count(sectionList) {
		return sectionList.reduce((total, section) => {
			if(visitedSections.has(section)) {
				return total;
			}

			visitedSections.add(section);

			return total + (section.IsMulti === true ? 1 : 0) + count(section.Sections ?? []);
		}, 0);
	}

	return count(sections);
}

class Controller {
	get hasMultiSections() {
		return countMultiSections(this.form?.Sections) > 1;
	}
}

export default angular.module("vesl.components.manage-report.multi-section-warning", []).component("multiSectionWarning", {
	template,
	controller: Controller,
	bindings: { form: "<" }
}).name;
